import { useEffect, useRef, useState } from 'react';

type TUseMonitoringFilterStateReturn = {
  openFilter: string;
  isOpenFilterPanel: boolean;
  filterRef: React.RefObject<HTMLDivElement>;
  onClearFilters: () => void;
  handleToggle: (component: string) => void;
  handleFilterPanel: () => void;
  handleClose: () => void;
};

export function useMentionFiltersState(): TUseMonitoringFilterStateReturn {
  const filterRef = useRef<HTMLDivElement | null>(null);
  const [openFilter, setOpenFilter] = useState<string>('');
  const [isOpenFilterPanel, setIsOpenFilterPanel] = useState<boolean>(true);

  const onClearFilters = () => {};

  const handleToggle = (component: string) => {
    setOpenFilter(prevComponent => (prevComponent === component ? '' : component));
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (filterRef.current && !(filterRef.current as Node).contains(event.target as Node)) {
      setOpenFilter('');
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleFilterPanel = () => {
    setIsOpenFilterPanel(!isOpenFilterPanel);
  };

  const handleClose = () => {
    setOpenFilter('');
  };

  return {
    isOpenFilterPanel,
    openFilter,
    filterRef,
    onClearFilters,
    handleToggle,
    handleFilterPanel,
    handleClose,
  };
}
